import { FormTab, Group, GroupTitle } from "ra-friendsofbabba";

import ChatIcon from "@material-ui/icons/Chat";
import RepliesField from "../fields/RepliesField";
import { useTranslate } from "react-admin";

const RepliesTab = (props) => {
  const translate = useTranslate();
  return (
    <FormTab
      {...props}
      icon={<ChatIcon />}
      label="resources.technical_reports.tabs.replies"
    >
      <Group wrapper>
        <GroupTitle
          title={translate("resources.technical_reports.tabs.replies.help")}
        />
      </Group>
      <RepliesField source="replies" />
    </FormTab>
  );
};

export default RepliesTab;
